module.exports = __webpack_public_path__ + "static/sport/swiper-4.33edefd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/swiper-4.png
// module id = OXwm
// module chunks = 0